import React, { Component } from 'react';
import { connect } from "react-redux";
import { Col, Grid, Image, Row } from 'react-bootstrap';
import { setData } from "../../redux/actionCreators";

import './advancedElectronicSignatureValidation.css';
import FooterContainer from '../../components/footer/FooterContainer';
import PageWithFooter from '../../components/page_with_footer/PageWithFooter';
import MainButton from '../../components/buttons/main_button/MainButton';

class AdvancedElectronicSignatureValidation extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    console.log(this.props.stepInfo.redirectUrl, this.props.stepInfo.signed, this.props.stepInfo.signatureAttempts);
    if (this.props.stepInfo.redirectUrl && !this.props.stepInfo.signed && this.props.stepInfo.signatureAttempts) {
      window.location.assign(this.props.stepInfo.redirectUrl);
    } else if (typeof this.props.stepInfo.redirectUrl === 'undefined' && this.props.stepInfo.signatureAttempts && !this.props.stepInfo.signed) {
      setTimeout(function () {
        window.location.reload();
      }, 2000);
    }
  }

  renderTitle() {
    const classTitle = <h1 className={'title'}>{this.props.stepInfo.title}</h1>

    return this.props.stepInfo.signatureAttempts ? classTitle : null;
  }

  renderIcon() {
    let icon;
    if (this.props.stepInfo.icon) {
      icon = require(`../../resources/images/${this.props.stepInfo.icon}`).default;
    }

    const classIcon = <div className="image"><Image src={icon} /></div>

    return this.props.stepInfo.signatureAttempts ? classIcon : null;
  }

  renderAlertMessage() {
    return (
      <>
        <Row>
          <Col xs={12}>
            <p className={'description'}>
              Serás redirigido a una serie de preguntas para validar tu identidad
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className='instruction-text'>
              Se ha agotado el número de reintentos de Firma avanzada. Para continuar debes responder unas
              preguntas de seguridad
            </div>
          </Col>
        </Row>
      </>
    );
  }

  renderMessage() {
    let text = '';
    let icon;
    if (this.props.stepInfo.signed) {
      text = 'Proceso completado exitosamente';
      icon = 'ok-circle.svg';
    } else {
      text = this.props.stepInfo.signatureAttempts ? 'Estás siendo redirigido a la plataforma de E-cert' : 'Has superado el límite de reintentos posibles';
      icon = this.props.stepInfo.signatureAttempts ? 'loading.gif' : 'alert-icons/alert-icon-10.svg';
    }

    const messageIcon = require(`../../resources/images/${icon}`).default;
    return (
      <>
        <Row>
          <Col xs={12}>
            <p className={'description'}>
              {text}
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="externImage">
              <Image src={messageIcon} />
            </div>
          </Col>
        </Row>
      </>
    );
  };

  renderButton() {
    return null;
  }

  render() {
    let data = this.props.data ? this.props.data : this.props.stepData;
    data = data ? data : {};
    return (
      <div className={'instruction-advance-electronic-signature-validation full-security'}>
        
                <PageWithFooter
                    footer={this.props.stepInfo.signed ? (
                        <FooterContainer>
                            <MainButton
                                onClick={this.props.nextStep}
                                text={this.props.stepInfo.buttonText}
                            />
                        </FooterContainer>
                    ) : null}
                >
                <Grid>
          <div className={'content'}>
            <div className={'break-top'}></div>
            <br />
            <Row>
              <Col xs={12}>
                {this.renderTitle()}
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                {this.renderIcon()}
              </Col>
            </Row>
            <br />
            {this.props.stepInfo.signatureAttempts ? this.renderMessage() : this.renderAlertMessage()}
            {this.renderButton()}
          </div>
        
                </Grid>
                </PageWithFooter>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    stepInfo: state.stepInfo,
    data: state.data,
    stepData: state.stepData,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setData: (data) => {
      dispatch(setData(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedElectronicSignatureValidation);
